/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {Order} from '../models/order';

export class OrderStore extends EntityStore {
  orders = [];
  selected = undefined;

  constructor(rootStore) {
    super(rootStore, 'orders', Api.orders, Order, true);
  }

  getDependencies() {
    return [
      {
        store: this,
        modelId: 'parentOrderId',
      },
      {
        store: this.rootStore.materialStore,
        modelId: 'materialId',
      },
      {
        store: this.rootStore.unitOfMeasurementStore,
        modelId: 'unitOfMeasureId',
      },
      {
        store: this.rootStore.batchStore,
        modelId: 'batchId',
      },
    ];
  }

  async searchByNo({params}) {
    return this.api.search(params).then((response) => response.data);
  }
}

decorate(OrderStore, {
  orders: observable,
  selected: observable,
});
